/** Generated by `pnpm content:audio`. The dialect-preview recording for each course. */
import type { Dialect } from './model.js';

export const PREVIEW_AUDIO_KEYS: Readonly<Record<Dialect, string>> = {
  'es-MX': 'content/es-MX/b528b51b2bbe7b0a5993248e9fa3ac8a.m4a',
  'es-ES': 'content/es-ES/9c3b7384be9eccc134e03b29ebc12f6c.m4a',
  'fr-FR': 'content/fr-FR/2529e8aef317c48d4542482e191af3d5.m4a',
  'fr-CA': 'content/fr-CA/a0c63430a75f04bb78dffbc825caceba.m4a',
  'pt-BR': 'content/pt-BR/1b2e3317e27fecce3961b479ce23ce8d.m4a',
  'pt-PT': 'content/pt-PT/632a14ecc4ece828d44b3fd266550cd6.m4a',
  'de-DE': 'content/de-DE/a8e5a4309583b848e480dba890a82ab7.m4a',
  'it-IT': 'content/it-IT/ee9401e55151846a18f9af5b982b6649.m4a',
  'ja-JP': 'content/ja-JP/68aa8dc29261edb097bd129bbd5d82c9.m4a',
  'ko-KR': 'content/ko-KR/72a1e5fbdc2c4a47b1028e422daff0d8.m4a',
  'zh-CN': 'content/zh-CN/1da34ce1035fc523f3a4fca0b21e1876.m4a',
  'zh-TW': 'content/zh-TW/a150c75fff33c60deeaef445699d43f5.m4a',
  'en-US': 'content/en-US/29b67dba69b17325ed3e872842224576.m4a',
  'en-GB': 'content/en-GB/8c841c3bb3de452e746739a40530ced5.m4a',
};

/** The tutor's reaction to a small mistake, one per persona, in English. */
export const PERSONA_AUDIO_KEYS: Readonly<Record<string, string>> = {
  mika: 'content/persona/24f427971b259acf2abc0595de5901d7.m4a',
  dani: 'content/persona/1c8abf7125592f656b26bb2bb205244f.m4a',
  sol: 'content/persona/16c187931d63721a55c255744826ac7b.m4a',
  rex: 'content/persona/dfa1e3a7cd978d3ee11f654d41601047.m4a',
  vex: 'content/persona/1f8e5bf01e46720eb0a93f6d9d117d73.m4a',
  nakamura: 'content/persona/703b676d2bde43bcb0dfc435d5cbc01b.m4a',
};
